import styled from '../../utils/styled';
import { Box, BoxProps } from '../../primitives';

export type FlexProps = BoxProps;

export const Flex = styled(Box)<FlexProps>`
    display: flex;
`;
